import React from 'react';
import { AutoComplete, Input, Space } from "antd";

export interface ICustomeAutoCompleteProps {
  value: string;
  options: string[];
  onSelect: (value: string) => void;
}

function CustomAutoComplete({  value, options, onSelect }: ICustomeAutoCompleteProps) {
  const [partAutocomplete, setPartAutocomplete] = React.useState(value);
  const [isEditable, setIsEditable] = React.useState(false);

  if (value && !isEditable) {
    return (
      <Space onClick={() => setIsEditable(true)}>
        {value}
      </Space>
    );
  }

  const filteredOptions = options
    .filter((option) => option.toLowerCase().includes(partAutocomplete.toLowerCase()))
    .map((option) => {
      return {
        label: option,
        value: option,
      };
    });
  filteredOptions.unshift({ label: `Add "${partAutocomplete}" as short name`, value: partAutocomplete });

  return (
    <AutoComplete
      style={{
        minWidth: 700,
        width: '100%'
      }}
      defaultValue={value}
      onSelect={(value) => {
        setIsEditable(false);
        onSelect(value)
      }}
      options={filteredOptions || []}
    >
      <Input
        placeholder="Part"
        value={partAutocomplete}
        onChange={(e) => {
          setPartAutocomplete(e.target.value);
        }}
      />
    </AutoComplete>
  );
}

export default CustomAutoComplete;
